/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsIcNodesCountFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsIcNodesCountFormat = ClosedEnum<
  typeof GetApiV3MetricsIcNodesCountFormat
>;

export type GetApiV3MetricsIcNodesCountRequest = {
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Subnet ID
   */
  subnet?: string | null | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsIcNodesCountFormat | undefined;
  /**
   * Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsIcNodesCountFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3MetricsIcNodesCountFormat
> = z.nativeEnum(GetApiV3MetricsIcNodesCountFormat);

/** @internal */
export const GetApiV3MetricsIcNodesCountFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3MetricsIcNodesCountFormat
> = GetApiV3MetricsIcNodesCountFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsIcNodesCountFormat$ {
  /** @deprecated use `GetApiV3MetricsIcNodesCountFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3MetricsIcNodesCountFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsIcNodesCountFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsIcNodesCountFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsIcNodesCountRequest$inboundSchema: z.ZodType<
  GetApiV3MetricsIcNodesCountRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  start: z.nullable(z.number()).default(null),
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsIcNodesCountFormat$inboundSchema.default("json"),
  step: z.number().int().default(7200),
});

/** @internal */
export type GetApiV3MetricsIcNodesCountRequest$Outbound = {
  start: number | null;
  subnet: string | null;
  end: number | null;
  format: string;
  step: number;
};

/** @internal */
export const GetApiV3MetricsIcNodesCountRequest$outboundSchema: z.ZodType<
  GetApiV3MetricsIcNodesCountRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3MetricsIcNodesCountRequest
> = z.object({
  start: z.nullable(z.number()).default(null),
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsIcNodesCountFormat$outboundSchema.default("json"),
  step: z.number().int().default(7200),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsIcNodesCountRequest$ {
  /** @deprecated use `GetApiV3MetricsIcNodesCountRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3MetricsIcNodesCountRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsIcNodesCountRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsIcNodesCountRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsIcNodesCountRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsIcNodesCountRequest$Outbound;
}

export function getApiV3MetricsIcNodesCountRequestToJSON(
  getApiV3MetricsIcNodesCountRequest: GetApiV3MetricsIcNodesCountRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsIcNodesCountRequest$outboundSchema.parse(
      getApiV3MetricsIcNodesCountRequest,
    ),
  );
}

export function getApiV3MetricsIcNodesCountRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3MetricsIcNodesCountRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsIcNodesCountRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MetricsIcNodesCountRequest' from JSON`,
  );
}
